module.exports = __webpack_public_path__ + "img/B9B37A_F1EED0_E5E4BA_DAD6A8-256px.ab3a13a6.png";